module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web20.f0680ceb.jpg";